import { Helmet } from 'react-helmet';
import { Outlet, useParams, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Section, SectionLink, SectionName } from '../components/Chrome';
import Icon from '../components/Icon';
import { SPACE } from '../utilities/queries';
import { useSpaceContext } from '../contexts/space';

const SpaceSettingsMainPage = () => {
  const params = useParams();
  const location = useLocation();
  const { spaceVars } = useSpaceContext();
  const { data, loading } = useQuery(SPACE, {
    variables: { slug: params.s, ...spaceVars },
  });

  return (
    <>
      <Helmet>
        <title>Main</title>
      </Helmet>
      <Section>
        <SectionName isSecondLevel>Main</SectionName>
        {!loading && data.space.planLevel >= 1 && (
          <SectionLink to="edit-space-banner">
            Edit space banner
            <Icon name="arrow-right" />
          </SectionLink>
        )}
        <SectionLink to="edit-space-name">
          Edit space name
          <Icon name="arrow-right" />
        </SectionLink>
        <SectionLink to="edit-space-slug">
          Edit space slug
          <Icon name="arrow-right" />
        </SectionLink>
        <SectionLink to="edit-space-icon">
          Edit space icon
          <Icon name="arrow-right" />
        </SectionLink>
      </Section>
      {location.pathname ===
      `/s/${params.s}/settings/main/edit-space-banner` ? (
        <>{data && data.space.planLevel >= 1 && <Outlet />}</>
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default SpaceSettingsMainPage;
